function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-15 40.914 4.93)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.42 7.488v-5.03C29.42.87 28.254-.297 27.05.067l-15.1 4.619H6.85A6.789 6.789 0 0 0 .262 9.468a6.694 6.694 0 0 0 5.25 8.444v6.379a1.434 1.434 0 0 0 1.435 1.434H8.86a1.435 1.435 0 0 0 1.434-1.434v-6.216h.957l15.703 4.619c1.262.373 2.468-.804 2.468-2.391v-5.9a2.495 2.495 0 0 0 1.912-2.363V9.85a2.497 2.497 0 0 0-1.913-2.362z",
  mask: "url(#bjcwmzhhqb)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M37.28 18.116a.956.956 0 0 1-1.191-1.087 9.563 9.563 0 0 0-3.037-8.71.958.958 0 0 1 1.282-1.423 11.475 11.475 0 0 1 3.641 10.45.956.956 0 0 1-.694.77z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.252 20.964a.956.956 0 0 1-1.124-1.313 11.953 11.953 0 0 0-4.893-15.194.956.956 0 0 1 .956-1.642 13.867 13.867 0 0 1 5.708 17.61c-.12.27-.36.469-.647.539z"
}));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 45,
  height: 36,
  viewBox: "0 0 45 36",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _ref);

export default __webpack_public_path__ + "static/media/announcements.09691a2a.svg";
export { SvgComponent as ReactComponent };